import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api } from "./api";
import { CONTENT_SLOTS } from "./contentSlots";

const ContentContext = createContext({
  content: {},
  getText: () => "",
  getUrl: () => "",
  reload: () => {},
  loading: true,
});

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/content");
      setContent(r.data || {});
    } catch (e) {
      // silent — fall back to defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const defaults = useMemo(() => {
    const map = {};
    CONTENT_SLOTS.forEach((s) => { map[s.key] = s.default; });
    return map;
  }, []);

  const getText = (key, fallback = "") => {
    const v = content[key];
    if (v === undefined || v === null || v === "") return defaults[key] ?? fallback;
    return v;
  };
  const getUrl = getText;

  return (
    <ContentContext.Provider value={{ content, getText, getUrl, reload: load, loading }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() { return useContext(ContentContext); }
